/**
 * The parent product's press, which is this product's credibility too. The asset IS the card — a
 * finished press card from intch.org, photo and headline baked in — so the image fills the tile and
 * the words live in its alt text. No article text is reproduced here; each card links to the
 * original.
 *
 * `photo` is the same card with only its picture kept (public/landing/press, cropped from `image` on
 * 2026-09-24, 12 px inset to lose the card's own rounded corners): the funnel-4 landing lays its own
 * cards out — larger, in its type — and needs the picture without the baked headline and lede.
 */
export type PressItem = {
  image: string
  photo: string
  href: string
  outlet: string
  date: string
  headline: string
  /** A podcast is listened to, not read — the card's call says so. */
  kind?: 'podcast'
}

export const PRESS_ITEMS: PressItem[] = [
  {
    image: '/media/m1.webp',
    photo: '/landing/press/m1.webp',
    href: 'https://open.spotify.com/episode/2h9mH2BCP1OTYHVb6i4Xze',
    outlet: 'Spotify Podcast',
    kind: 'podcast',
    date: 'Jul 2026',
    headline: 'The New Career Playbook: Fractional, Flexible, Future-Ready',
  },
  {
    image: '/media/m2.webp',
    photo: '/landing/press/m2.webp',
    href: 'https://www.eu-startups.com/2026/07/why-european-founders-must-master-sovereign-flexibility/',
    outlet: 'EU-Startups',
    date: 'Jul 2026',
    headline: 'Why European founders must master “sovereign flexibility”',
  },
  {
    image: '/media/m3.webp',
    photo: '/landing/press/m3.webp',
    href: 'https://www.ft.com/content/0b67e331-4ff0-4af6-85b7-0d7d6710d603',
    outlet: 'Financial Times',
    date: 'Jul 2026',
    headline: 'How to stop AI becoming the enemy of younger workers',
  },
  {
    image: '/media/m4.webp',
    photo: '/landing/press/m4.webp',
    href: 'https://www.fastcompany.com/91563209/why-we-hired-a-head-of-people-during-the-age-of-ai',
    outlet: 'Fast Company',
    date: 'Jun 2026',
    headline: 'Why we hired a head of people during the age of AI',
  },
  {
    image: '/media/m6.webp',
    photo: '/landing/press/m6.webp',
    href: 'https://www.ft.com/content/e6010ebe-be98-4cd4-bbf6-741d6dbfd300',
    outlet: 'Financial Times',
    date: 'Jun 2026',
    headline: 'Token economics is the wrong model to adopt',
  },
  {
    image: '/media/m5.webp',
    photo: '/landing/press/m5.webp',
    href: 'https://www.inspiring-workplaces.com/content/2026-north-american-inspiring-workplaces-in-association-with-engagedly-announced',
    outlet: 'Inspiring Workplaces',
    date: 'Jun 2026',
    headline: '2026 North American Inspiring Workplaces announced',
  },
]
